module.exports = __webpack_public_path__ + "img/01_noff_open_L3.e447b597.svg";